import gsap from 'gsap';
import {
	Sizes,
	generateAnimations,
	destroyAnimations,
	generateTriggers,
} from '../utils';

export class MouseHover {
	constructor( selector, options = {} ) {
		// General
		this.elements = gsap.utils.toArray( selector );
		this.sizes = new Sizes();
		this.options = {
			...options,
			devices: options?.devices || [ 'Desktop', 'Tablet', 'Mobile' ],
		};
		this.isEnable = false;

		// Animations Data
		this.timelines = [];
		this.textInstances = [];

		// Triggers Data
		this.enterTrigger = {};
		this.leaveTrigger = {};
		this.enterFn = [];
		this.leaveFn = [];
		this.triggerTimer = [];

		this.enterFuncs = [];
		this.leaveFuncs = [];
	}

	init() {
		if (
			! this.elements?.length ||
			this.isEnable ||
			! this.options.devices.includes( this.sizes.device )
		)
			return;
		const enterSettings = this.options.mouseenter;
		const leaveSettings = this.options.mouseleave;
		this.elements.forEach( ( ele, index ) => {
			// Generate Animations
			const [ theTimelines, theTextInstance ] = generateAnimations(
				ele,
				this.options.animations
			);
			this.timelines[ index ] = theTimelines;
			this.textInstances[ index ] = theTextInstance;

			if ( enterSettings ) {
				this.enterFn[ index ] = generateTriggers(
					enterSettings,
					this.timelines[ index ],
					this.enterTrigger,
					this.triggerTimer,
					index
				);

				this.enterFuncs[ index ] = () => this.#enter( index );
				ele.addEventListener( 'mouseenter', this.enterFuncs[ index ] );
			}

			if ( leaveSettings ) {
				this.leaveFn[ index ] = generateTriggers(
					leaveSettings,
					this.timelines[ index ],
					this.leaveTrigger,
					this.triggerTimer,
					index
				);

				this.leaveFuncs[ index ] = () => this.#leave( index );
				ele.addEventListener( 'mouseleave', this.leaveFuncs[ index ] );
			}
		} );
		this.isEnable = true;
	}

	kill() {
		if ( ! this.isEnable ) return;
		this.elements.forEach( ( item, index ) => {
			item.removeEventListener( 'mouseenter', this.enterFuncs[ index ] );
			item.removeEventListener( 'mouseleave', this.leaveFuncs[ index ] );
			this.enterFn[ index ]?.kill();
			this.leaveFn[ index ]?.kill();
		} );
		destroyAnimations(
			this.elements,
			this.options.animations,
			this.timelines,
			this.textInstances
		);
		this.timelines = [];
		this.textInstances = [];
		this.enterTrigger = {};
		this.leaveTrigger = {};
		this.enterFn = [];
		this.leaveFn = [];
		this.triggerTimer = [];
		this.enterFuncs = [];
		this.leaveFuncs = [];
		this.isEnable = false;
	}

	resize() {
		this.kill();
		this.init();
	}

	destroy() {
		this.kill();
		this.elements = null;
		this.sizes = null;
		this.options = null;
		this.isEnable = null;
		this.timelines = null;
		this.textInstances = null;
		this.enterTrigger = null;
		this.leaveTrigger = null;
		this.enterFn = null;
		this.leaveFn = null;
		this.triggerTimer = null;
		this.enterFuncs = null;
		this.leaveFuncs = null;
	}

	#enter( index ) {
		this.enterFn[ index ]?.run();
	}

	#leave( index ) {
		this.leaveFn[ index ]?.run();
	}
}
